import client from '@/api/client.js'
import store from "@/store";
export default {
    methods: {
        async getEmploymentList() {
            var response = await client().get(store.state.apiRouteRoot + "employment", { meta: { clientApiMethod: 'getEmploymentList' } })
            return response?.data;
        },
    }
}